export default __webpack_public_path__ + "static/media/node.ab466c62.svg";